import TokenExpirationService from './tokenExpirationService';

export const API_BASE_URL = "https://api.easyeauction.com/api";

export const validateSession = (): boolean => {
  if (!TokenExpirationService.isSessionValid()) {
    console.warn("Session expired, logging out...");
    
    // Clear all auth data
    localStorage.removeItem("auctionUser");
    localStorage.removeItem("authToken");
    localStorage.removeItem("pendingPhoneNumber");
    localStorage.removeItem("pendingEmail");
    localStorage.removeItem("sessionId");
    TokenExpirationService.clearLoginTimestamp();
    
    // Redirect to login page
    if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
      alert("Your session has expired. Please login again.");
      window.location.href = '/login';
    }
    
    return false;
  }
  
  return true;
};

/**
 * Enhanced fetch wrapper that validates session before making API calls
 * Use this instead of native fetch for authenticated requests
 */
export const secureFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  // Check session validity before making the request
  if (!validateSession()) {
    throw new Error("Session expired");
  }
  
  // Make the actual fetch request
  const response = await fetch(url, options);
  
  // Check if the response indicates token expiration (401 or 403)
  if (response.status === 401 || response.status === 403) {
    console.warn("Unauthorized response, session may have expired");
    validateSession(); // This will trigger logout and redirect
    throw new Error("Unauthorized - session expired");
  }
  
  return response;
};

